import { IdentificationMethod } from 'types/ui';
import { QueryStatus } from '@tanstack/react-query';
import useClientQuery from './useClientQuery';

interface UseIdentificationMethodQuery {
  status: QueryStatus;
  identificationMethod: IdentificationMethod | null;
}

const useIdentificationMethodQuery = (): UseIdentificationMethodQuery => {
  const { status, data } = useClientQuery();

  return {
    status,
    identificationMethod: resolveIdentificationMethod(
      data?.markedForManualIdentification,
    ),
  };
};

export default useIdentificationMethodQuery;

const resolveIdentificationMethod = (
  markedForManutalIdentification?: boolean,
): IdentificationMethod | null => {
  if (markedForManutalIdentification === true) return 'manual';
  else if (markedForManutalIdentification === false) return 'online-bank';
  else return null;
};
